import {
  GET_FORM_WITH_ANSWERS,
  get_headers,
  get_project_id
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from "axios";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';

export default {
  name: 'EntityProfileOverview',
  props: {
    entityId: {
      type: [String, Number],
      required: true
    }
  },
  mixins: [alert_mixin],
  data: () => ({
    headers: get_headers(),
    project_id: get_project_id(),
    active_status_tab: 0,
    main_stages: [],
    editing_stage: '',
    selected_transitions: [],
    selected_stage: '',
    filtered_stages: [],
    loading: false,
    error: null,
    new_rule: {
      name: '',
      expression: ''
    },
    rules: new Map(),
    rule_id: null,
    show_rule_modal: false,
    current_editing_stage: null,
    available_rules: [],
    active_main_tab: 0, // Track the active main form
    active_section_tab: 0, // Track the active section within the form
  }),
  watch: {
    entityId: {
      immediate: true,
      handler(new_id) {
        if (new_id) {
          this.fetch_entities_form_with_answers(); // No need to pass parameter
        }
      }
    }
  },
  computed: {
    current_sections() {
      return this.main_stages[this.active_main_tab]?.sub_stages || [];
    }
  },
  mounted() {
    if (this.entityId) {
      this.fetch_entities_form_with_answers();
    }
  },
  methods: {
    handleNumberInput(event, field) {
      const value = event.target.value.replace(/\D/g, '')
      Reflect.set(this.safe_form_data, field.model, value)
      event.target.value = value
    },
    fetch_entities_form_with_answers() {
        this.loading = true;
        const query_params = { profile_role_form_id: this.entityId };
        
        axios.get(
          GET_FORM_WITH_ANSWERS,
          { 
            headers: this.headers,
            params: query_params
          }
        ).then(response => {
          if (response.data.status === 'success') {
            this.main_stages = this.map_backend_to_sections(response.data.data);
          }
        }).finally(() => this.loading = false);
    },

    map_backend_to_sections(form_data) {

      return [{
        id: form_data.id,
        name: form_data.form_name,
        expanded: true,
        sub_stages: form_data.sections.map(section => ({
          id: section.id,
          name: section.name,
          description: '',
          is_mandatory: section.is_verified,
          editing: false,
          fields: section.questions.map(question => 
            this.map_question_to_field(question)
        )}))
      }];
    },

    map_question_to_field(question) {
      const base_field = {
        id: question.id,
        label: question.question_text,
        required: question.is_mandatory,
        value: question.answer
      };

      switch (question.question_type.question_type) {
        case 'short_text': 
          return { ...base_field, type: 'text' };

        case 'long_text': 
          return { ...base_field, type: 'textarea' };

        case 'single_select': 
          return {
            ...base_field,
            type: 'select',
            options: question.multi_select_choices.map(choice => ({
              value: choice.choice,
              text: choice.choice
            }))
          };
            
        case 'multi_select': {
          // Keep the block here since we have multiple statements
          const selected_values = question.answer ? question.answer.split(',') : [];
          return {
            ...base_field,
            type: 'checkbox-group',
            options: question.multi_select_choices.map(choice => ({
              value: choice.id,
              text: choice.choice,
              checked: selected_values.includes(choice.choice)
            }))
          };
        }
          
        case 'file': 
          return {
            ...base_field,
            type: 'link',
            file_name: question.answer?.file_name || 'No file uploaded',
            url: question.answer?.presigned_url || '#'
          };
            
        case 'number': 
          return { ...base_field, type: 'number' };
        
        case 'date': 
          return { ...base_field, type: 'date' };
        
        default: 
          return { ...base_field, type: 'text' };
      }
    },

    change_main_tab(index) {
      this.active_main_tab = index;
      this.active_section_tab = 0; // Reset to first section when changing forms
    },

    change_section_tab(index) {
      this.active_section_tab = index;
    },
    change_status_tab(index) {
      this.active_status_tab = index;
    },
  }
}